import React, { useState } from 'react';
import { FormControl, Input, InputLabel, TextField, withStyles } from '@material-ui/core';
import clsx from 'clsx';

const styles = (theme) => ({
    formControl: {
        width: '100%',
    },
});

const BiosPasswordForm = (props) => {
    const { classes, translations, formikProps, index } = props;

    const { values, handleBlur, errors, touched, handleChange } = formikProps;

    const [passwordVisible, setPasswordVisible] = useState(!values.BiosPasswords.Passwords[index]?.Password);

    return (
        <>
            <TextField
                name={`BiosPasswords.Passwords[${index}].Description`}
                value={values.BiosPasswords.Passwords[index]?.Description || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                error={
                    !!(
                        errors?.BiosPasswords?.Passwords?.[index]?.Description &&
                        touched?.BiosPasswords?.Passwords?.[index]?.Description
                    )
                }
                placeholder={translations['description'] || 'Description'}
                label={translations['description'] || 'Description'}
                margin={'dense'}
                fullWidth={true}
                type="text"
            />
            <FormControl className={clsx(classes.margin, classes.formControl)}>
                <InputLabel htmlFor={`BiosPasswords.Passwords[${index}].Password`}>
                    {translations['password'] || 'Password'}
                </InputLabel>
                <Input
                    disabled={!passwordVisible}
                    type={passwordVisible ? 'text' : 'password'}
                    name={`BiosPasswords.Passwords[${index}].Password`}
                    value={values.BiosPasswords.Passwords[index]?.Password || ''}
                    onChange={handleChange}
                    onBlur={(e) => {
                        setPasswordVisible(false);
                        handleBlur(e);
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            setPasswordVisible(false);
                        }
                    }}
                    error={
                        !!(
                            errors?.BiosPasswords?.Passwords?.[index]?.Password &&
                            touched?.BiosPasswords?.Passwords?.[index]?.Password
                        )
                    }
                    placeholder={translations['password'] || 'Password'}
                    label={translations['password'] || 'Password'}
                    fullWidth={true}
                    inputProps={{
                        form: {
                            autoComplete: 'off',
                        },
                    }}
                />
            </FormControl>
            <TextField
                type="hidden"
                disabled={true}
                name={`BiosPasswords.Passwords[${index}].PasswordID`}
                value={values.BiosPasswords.Passwords[index]?.PasswordID || null}
            />
        </>
    );
};

export default withStyles(styles, { withTheme: true })(BiosPasswordForm);
